<template>
    <v-container>
        <v-col cols="12" class="text-center">
            <v-row :class="{ 'mt-10': !$vuetify.breakpoint.mdAndUp, 'mt-10 pt-10': $vuetify.breakpoint.mdAndUp }">
                <!-------------- esporta lead  ----------------->

                <v-col cols="4" class="d-flex justify-center">
                    <v-card flat> </v-card>
                </v-col>

                <!-------------- title ----------------->
                <v-col cols="4" class="d-flex justify-center">
                    <h1>sezione log</h1>
                </v-col>

                <!-------------- filter ----------------->
                <v-col cols="4" class="d-flex justify-center">
                    <v-row>
                        <!-- Filtro per Azione -->
                        <v-col cols="6">
                            <v-select :items="availableaction" v-model="filteraction" label="filtra azione" @change="getDataFromApi"></v-select>
                        </v-col>

                        <!-- Filtro per Agente -->
                        <v-col cols="6">
                            <v-autocomplete
                                v-model="filterAgent"
                                :items="agents"
                                :loading="loadingAgents"
                                :search-input.sync="searchAgent"
                                item-text="name"
                                item-value="name"
                                label="filtra agente"
                                hide-no-data
                                hide-selected
                                clearable
                                @input="getDataFromApi"
                            >
                                <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
        <!------------- GRIGLIE ----------------->
        <v-card class="marginScroll">
            <v-data-table
                :headers="headers"
                :items="logs"
                :options.sync="options"
                :server-items-length="totalLogs"
                :loading="loading"
                :search="search"
                class="pt-3"
                :footer-props="{ itemsPerPageOptions: [10, 30, 50, 100], showFirstLastPage: true }"
                @update:options="updateUrl"
                :mobile-breakpoint="1270"
                show-select
                v-model="selectedLogs"
            >
                <template v-slot:top>
                    <v-menu transition="slide-y-transition" bottom v-if="selectedLogs.length && filteraction == 'disabled'" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" class="ml-6 mt-n2 mb-4" v-bind="attrs" v-on="on"> azione </v-btn>
                            {{ selectedLogs.length }}
                            log {{ ('selezionato', selectedLogs.length > 1 ? 2 : 1) }}
                        </template>
                        <v-list class="text-uppercase">
                            <v-list-item @click="showRestoreDialogSelect">
                                <v-list-item-title class="ma-5 pointer"
                                    ><v-icon color="black" class="mb-1" left> history </v-icon> ripristina
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
                <template #[`item.attributes.lead.data.attributes.Name`]="{ item, value }">
                    <span class="pointer blue--text" @click="openDetails(item)">{{ value }}</span>
                </template>
                <template #[`item.attributes.date`]="{ value }">
                    {{ $moment(value).format('DD/MM/YYYY HH:mm') }}
                </template>
                <template #[`item.attributes.editdate`]="{ value }">
                    {{ !value ? '' : $moment(value).format('DD/MM/YYYY HH:mm') }}
                </template>
            </v-data-table>

            <v-dialog v-model="showRestoreConfirmation" max-width="500">
                <v-card outlined>
                    <v-card-title class="text-h5 grey justify-center lighten-2"> confermi </v-card-title>

                    <v-card-text class="mt-6, text-center mt-6"> {{ restoreDialogMsg }}</v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-btn text @click="cancelRestore">annulla</v-btn>
                        <v-spacer></v-spacer>

                        <v-btn color="red" text @click="restoreSelect()">ripristina</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>

        <v-navigation-drawer v-model="infoLead" :class="{ 'full-screen': infoLeadExpand }" :width="$vuetify.breakpoint.smAndDown ? '100%' : '600px'" fixed bottom>
            <v-list nav dense>
                <v-col cols="12">
                    <v-container class="d-flex flex-row mb-n2">
                        <v-btn color="error" @click="closeDetails()"> chiudi' </v-btn>
                        <v-spacer></v-spacer>

                        <v-spacer></v-spacer>
                        <v-btn color="success" @click=";(sidebar = !sidebar), (infoLeadExpand = !infoLeadExpand)">
                            {{ !infoLeadExpand ? 'espandi' : 'restringi' }}
                        </v-btn>
                    </v-container>
                    <cpLead
                        class="max"
                        v-if="selectedLead"
                        :pid="selectedLead"
                        :pbuttons="{ backArrow: false, merge: false }"
                        :title="false"
                        :sidebar="sidebar"
                        :nobuttons="true"
                    ></cpLead>
                </v-col>
            </v-list>
        </v-navigation-drawer>
    </v-container>
</template>

<script>
import cpLead from '@/components/cpLead.vue'

export default {
    name: 'Logs',
    components: { cpLead },
    data() {
        return {
            logs: [],
            totalLogs: 0,
            loading: false,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
                groupBy: [],
                groupDesc: [],
                multiSort: null,
                mustSort: null
            },
            timeoutQuery: null,
            search: '',

            showRestoreConfirmation: false,
            restoreDialogCall: null,
            modalFilter: false,
            baseUrl: '',

            headers: [
                {
                    text: 'data',
                    value: 'attributes.date',
                    field: 'date',
                    sortable: true
                },
                { text: 'agente', value: 'attributes.agent.data.attributes.Name', field: 'agent', sortable: false },
                {
                    text: 'lead',
                    value: 'attributes.lead.data.attributes.Name',
                    field: 'lead',
                    sortable: false
                },
                {
                    text: 'azione',
                    value: 'attributes.action',
                    field: 'action',
                    sortable: true
                }
            ],

            selectedLogs: [],
            changinurl: false,

            addto: [],

            selectDay: null,
            loadingDay: false,

            mergeLeads: [],
            openmerge: false,

            restoreDialogMsg: '',
            filteraction: 'disabled',
            availableaction: ['disabled', 'merged', 'restored', 'modified', 'created', 'login'],
            filterAgent: null,
            agents: [],
            loadingAgents: false,
            searchAgent: null,
            infoLeadExpand: false,
            infoLead: false,
            selectedLead: null,
            sidebar: true
        }
    },
    watch: {
        searchAgent(val) {
            if (val && val.length >= 3) {
                this.getAgentsFromApi(val)
            } else if (!val || val.length == 0) {
                this.agents = []
            }
        }
    },
    async created() {
        if (!this.$permission(this.$auth.utente.role.name, 'AdminPage')) {
            this.$router.push('/')
        }
        this.baseUrl = window.location.origin
        this.changinurl = true
        if (this.$route.query.page) {
            this.options.page = parseInt(this.$route.query.page)
        }
        if (this.$route.query.items) {
            this.options.itemsPerPage = parseInt(this.$route.query.items)
        }
        if (this.$route.query.sortBy) {
            this.options.sortBy[0] = this.$route.query.sortBy
            if (this.$route.query.sortDesc) {
                this.options.sortDesc[0] = this.$route.query.sortDesc
            }
        }
        if (this.$route.query.agent) {
            this.filterAgent = this.$route.query.agent
        }

        this.changinurl = false
        await this.getDataFromApi()
    },
    methods: {
        async getAgentsFromApi(searchTerm = '') {
            if (!searchTerm || searchTerm.length < 3) {
                this.agents = []
                this.loadingAgents = false
                return
            }
            this.loadingAgents = true
            try {
                let filters = {}

                // Se c'è un termine di ricerca, filtra per nome

                filters['filters[Name][$containsi]'] = searchTerm

                const response = await this.$http.get('agentlist', {
                    populate: ['user', 'user.role', 'zones', 'zones.leads', 'zones.leads.parent_lead'],
                    pageSize: 50,
                    page: 1,
                    ...filters
                })

                if (response && response.results) {
                    this.agents = response.results.map((agent) => ({
                        id: agent.id,
                        name: agent.name
                    }))
                }
            } catch (error) {
                console.error('Errore nel caricamento agenti:', error)
            } finally {
                this.loadingAgents = false
            }
        },
        closeDetails() {
            this.selectedLead = null
            this.infoLead = false
            this.infoLeadExpand = false
        },
        openDetails(item) {
            this.selectedLead = item.attributes.lead.data.id
            this.infoLead = true
        },
        showRestoreDialogSelect() {
            this.restoreDialogMsg = 'sei sicuro di voler ripristinare i lead selezionati'
            this.showRestoreConfirmation = true
        },

        clearFilters() {
            // Reset all filter
        },
        async updateUrl() {
            if (this.changinurl) return

            let query = { ...this.$route.query }
            this.changinurl = true
            if (this.options.page > 1) {
                if (this.$route.query.page != this.options.page) {
                    query.page = this.options.page
                }
            } else {
                delete query.page
            }
            if (this.options.itemsPerPage > 10) {
                if (this.$route.query.items != this.options.itemsPerPage) {
                    query.items = this.options.itemsPerPage
                }
            } else {
                delete query.items
            }
            if (this.filterAgent) {
                query.agent = this.filterAgent
            } else {
                delete query.agent
            }
            if (this.options.sortBy.length) {
                if (this.$route.query.sortBy != this.options.sortBy) {
                    query.sortBy = this.options.sortBy
                    if (this.options.sortDesc.length && this.$route.query.sortDesc != this.options.sortDesc) {
                        query.sortDesc = this.options.sortDesc
                    }
                }
            } else {
                delete query.sortBy
                delete query.sortDesc
            }

            this.$router
                .replace({
                    path: this.$route.path,
                    query: query
                })
                .catch((err) => {})

            await this.getDataFromApi()
            this.changinurl = false
        },

        setFilter() {
            this.options.page = 1
            this.selectedLeads = []
            this.updateUrl()
            this.modalFilter = false
        },

        async getDataFromApi() {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options
            let filters = {}

            let cc = 0
            if (this.filterAgent) {
                filters[`filters[$and][${cc}][agent][Name][$eqi]`] = this.filterAgent
                cc++
            }
            if (this.filteraction == 'restored') {
                if (!this.headers.find((h) => h.field == 'editdate')) {
                    this.headers.push({
                        text: 'modifica-data',
                        value: 'attributes.editdate',
                        field: 'editdate',
                        sortable: true
                    })
                }

                if (!this.headers.find((h) => h.field == 'editagent')) {
                    this.headers.push({
                        text: 'modifica-agente',
                        value: 'attributes.editagent.data.attributes.Name',
                        field: 'editagent',
                        sortable: false
                    })
                }
            } else {
                if (this.headers.find((h) => h.field == 'editdate')) {
                    this.headers = this.headers.filter((h) => h.field != 'editdate')
                }
                if (this.headers.find((h) => h.field == 'editagent')) {
                    this.headers = this.headers.filter((h) => h.field != 'editagent')
                }
            }
            filters[`filters[$and][${cc}][action][$eqi]`] = this.filteraction

            cc++

            let sort = 'date:desc'
            if (sortBy.length) {
                const el = this.headers.find((x) => x.value == sortBy[0])
                sort = el.field.concat(sortDesc[0] ? ':desc' : '')
            }
            const docs = await this.$http.get(`actionlogs`, {
                'populate': ['lead', 'agent', 'editagent'],
                'sort': sort,
                'pagination[page]': page,
                'pagination[pageSize]': itemsPerPage,
                ...filters
            })

            this.logs = docs.data || docs
            this.totalLogs = docs.meta.pagination.total ? docs.meta.pagination.total : 0
            this.loading = false
        },

        async restoreSelect() {
            if (!this.$permission(this.$auth.utente.role.name, 'restoreLead')) {
                return
            }

            try {
                for (const log of this.selectedLogs) {
                    await this.$http.put(`leads/${log.attributes.lead.data.id}`, {
                        data: { disabled: false }
                    })
                    await this.$http.put(`actionlogs/${log.id}`, {
                        data: { editagent: this.$auth.utente.agent.id, action: 'restored', editdate: this.$moment().format() }
                    })
                }

                this.getDataFromApi()
                this.selectedLogs = []
                this.cancelRestore()
                this.$notify({
                    group: 'notifica',
                    title: 'successo',
                    text: 'leads-selezionati-ripristinati-con-successo',
                    type: 'success'
                })
            } catch (error) {
                console.error(error)
                this.cancelRestore()
                this.$notify({
                    group: 'notifica',
                    title: 'errore',
                    text: 'si e verificato un errore durante il ripristino dei leads selezionati',
                    type: 'error'
                })
            }
        },
        cancelRestore() {
            this.showRestoreConfirmation = false
            this.restoreDialogMsg = ''
        }
    }
}
</script>
<style>
/* Stile CSS personalizzato */
.no-underline {
    text-decoration: none;
}
.icon {
    width: 20px;
}
h4 {
    text-align: center;
    text-transform: uppercase;
}
</style>
